const normalizePath = (path: string): string => {
  if (!path) return '/'
  if (path === '/') return '/'
  return path.replace(/\/+$/, '') || '/'
}

export const resolveAdminBasePath = (_pathname?: string, _hostname?: string): '' => ''

export const buildAdminPath = (
  path = '',
  _basePath: '' = resolveAdminBasePath(),
): string => {
  const normalizedPath = normalizePath(path.startsWith('/') ? path : `/${path}`)
  return normalizedPath
}

export const getAdminHomePath = (): string => buildAdminPath('/')
export const getAdminLoginPath = (): string => buildAdminPath('/login')
export const getAdminForgotPasswordPath = (): string => buildAdminPath('/forgot-password')
export const getAdminResetPasswordPath = (): string => buildAdminPath('/reset-password')
